import React, {CSSProperties, PropsWithChildren} from 'react';
import styles from "./Fold.module.scss";
import cx from "classnames";


function FoldMain({children, backgroundImage, className = '' }: PropsWithChildren<{ className?: string; backgroundImage?: string }>) {
    return (
        <div
            className={`text-center ${styles.FoldMain} ${className}`}
            style={backgroundImage ? {backgroundImage: `url(${backgroundImage})`} : undefined}
        >
            {children}
        </div>
    );
}

function FoldExtension({ children, backgroundColor }: PropsWithChildren<{ backgroundColor?: string }>) {
    return (
        <div
            className={`text-center ${styles.FoldExtension}`}
            style={backgroundColor ? { backgroundColor } : undefined}
        >
            {children}
        </div>
    );
}

function Fold({
    children, backgroundImage, className = '', style = {}, fullHeight, overlay = ''
}: PropsWithChildren<{
    className?: string;
    backgroundImage?: string;
    style?: CSSProperties;
    overlay?: 'dark' | '';
    fullHeight?: boolean;
}>) {
    return (
        <div
            className={cx({
              [`text-center ${styles.Fold} ${className}`]: true,
              [styles.FullHeight]: fullHeight,
              [styles.OverlayDark]: overlay === 'dark',
            })}
            style={backgroundImage ? {backgroundImage: `url(${backgroundImage})`, ...style} : style}
        >
            {children}
        </div>
    )
}

Fold.Main = FoldMain
Fold.Extension = FoldExtension


export default Fold

